import ContextualContent from './ContextualContent';
import { ContextualContentProps, ContextualContentValueProps } from './types';

export type { ContextualContentProps, ContextualContentValueProps };
export default ContextualContent;
